<template>
  <Layout>
    <div>
      <div class="relative px-4 sm:px-6 lg:px-8">
        <div class="text-lg max-w-prose mx-auto">

          <img :src="image"
               class="w-full aspect-video rounded-lg object-center object-cover mx-auto"
               :alt="'Kursbild ' + course.title"/>

          <h1 class="mt-8">
            <span
                class="mt-2 block text-3xl text-center leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
                {{ course.title }}
            </span>
          </h1>

          <h2 class="mt-2 block text-xl text-center leading-8 tracking-tight text-gray-900">
            {{ course.subtitle ? course.subtitle : '' }}</h2>

          <p v-html="course.content" class="mt-8 text-xl text-gray-500 leading-8"></p>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../components/layout/LayoutDefault.vue";
import Headline from "../components/basic/Headline.vue";

export default {
  components: {
    Layout,
    Headline
  },
  props: {
    course: Object,
    image: String
  }
}
</script>
